import { IS_CLIENT } from "@/common/api";
import { IAppProgress, IAppStatus, IAppCleanStatus } from "@/common/interface";
import {
  SET_APP_PROGRESS,
  SET_APP_STATUS,
  SET_APP_CLEAN_STATUS,
} from "@/store/actionTypes";
import { initAllAppStatus } from "@q/softCore";
import { Dispatch } from "redux";

export const setAppStatus = (data: IAppStatus) => ({
  type: SET_APP_STATUS,
  data,
});

export const setAppProgress = (data: IAppProgress) => ({
  type: SET_APP_PROGRESS,
  data,
});

export const setAppCleanStatus = (data: IAppCleanStatus) => ({
  type: SET_APP_CLEAN_STATUS,
  data,
});

export const asyncInitAllAppStatus =
  (data: number[]) => (dispatch: Dispatch) => {
    if (IS_CLIENT) {
      return initAllAppStatus(data).then((softStatusMap: IAppStatus) => {
        console.log("asyncInitAllAppStatus", softStatusMap);
        dispatch(setAppStatus(softStatusMap));
      });
    }
    return Promise.resolve();
  };
